import { clsx } from 'clsx';
import InboxIcon from '@interxfi/design-system/icons/react/icon-inbox';
import { useLayoutContext } from '../../../../components/layout/context';
import { useOpenCaseCount } from '../status-badge/use-open-case-count';
import styles from './inbox-nav-icon.module.scss';

export function InboxNavIcon() {
  const { showCollapsedSidebar } = useLayoutContext();
  const { count } = useOpenCaseCount();

  return (
    <span className={clsx(styles.inboxNavIcon, showCollapsedSidebar && count > 0 && styles.hasOpenCases)}>
      <InboxIcon aria-hidden />
    </span>
  );
}
